module.exports = __webpack_public_path__ + "static/media/admin_img.3a84ec1f.jpg";